import request from '@/utils/http.js'

/**
 * @description 获取登录验证码
 * @returns {Promise}
 * @param params
 */
export function getLoginCaptcha (params) {
  return request.post({
    url: '/user/getLoginCaptcha',
    params
  })
}

/**
 * @description 用户登录
 * @returns {Promise}
 * @param params
 */
export function login (params) {
  return request.post({
    url: '/user/login',
    params
  })
}

/**
 * 学生注册
 * @param params
 * @returns {Promise}
 */
export function register (params) {
  return request.post({
    url: '/user/register',
    params
  })
}

/**
 * 家长/老师注册
 * @param params
 * @returns {Promise}
 */
export function parentAdd (params) {
  return request.post({
    url: '/parent/add',
    params
  })
}
